import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'


interface CartLoadingProps {
  className?: string;
}

export default function CartLoading (_props: CartLoadingProps) {
  return (
    <SkeletonTheme>
      <Skeleton
        count={3}
        width={'100%'}
        height={80}
        style={{
          borderRadius: 6,
          marginBottom: 20,
        }}
      />
    </SkeletonTheme>
  )
}
